var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48035 9.27344C9.30877 9.27344 9.98035 8.60186 9.98035 7.77344C9.98035 6.94501 9.30877 6.27344 8.48035 6.27344C7.65192 6.27344 6.98035 6.94501 6.98035 7.77344C6.98035 8.60186 7.65192 9.27344 8.48035 9.27344Z",
    fill: "#9A999D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48035 0.273438C4.34503 0.273438 0.980347 3.49141 0.980347 7.44531C0.980347 9.32828 1.83863 11.8323 3.53128 14.8881C4.89066 17.3416 6.46332 19.5602 7.28128 20.6641C7.4195 20.8527 7.60022 21.0061 7.80879 21.1118C8.01736 21.2176 8.24791 21.2727 8.48175 21.2727C8.71559 21.2727 8.94614 21.2176 9.15471 21.1118C9.36328 21.0061 9.544 20.8527 9.68222 20.6641C10.4988 19.5602 12.0728 17.3416 13.4322 14.8881C15.1221 11.8333 15.9803 9.32922 15.9803 7.44531C15.9803 3.49141 12.6157 0.273438 8.48035 0.273438ZM8.48035 10.7734C7.887 10.7734 7.30698 10.5975 6.81364 10.2678C6.32029 9.9382 5.93577 9.46967 5.70871 8.92149C5.48165 8.37331 5.42224 7.77011 5.53799 7.18817C5.65375 6.60622 5.93947 6.07167 6.35903 5.65212C6.77858 5.23256 7.31313 4.94684 7.89508 4.83108C8.47702 4.71533 9.08022 4.77474 9.6284 5.0018C10.1766 5.22886 10.6451 5.61338 10.9748 6.10673C11.3044 6.60007 11.4803 7.18009 11.4803 7.77344C11.4795 8.56882 11.1631 9.33138 10.6007 9.8938C10.0383 10.4562 9.27573 10.7726 8.48035 10.7734Z",
    fill: "#9A999D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.f21e6965ca3161ff9d22665b8eed4542.svg";
export { ForwardRef as ReactComponent };